<script setup>
import { Icon } from '@components'
</script>

<template>
    <div class="date-loader">
        <!-- calendar header -->
        <div class="date-loader__header">
            <Icon name="chevronLeft" size="20px" class="date-loader__header-icon" />
            <div class="date-loader__header-title"></div>
            <Icon name="chevronRight" size="20px" class="date-loader__header-icon" />
        </div>

        <!-- calendar days -->
        <div class="date-loader__days">
            <div v-for="i in 7" class="date-loader__days-item"></div>
        </div>

        <!-- calendar dates -->
        <div class="date-loader__dates">
            <div v-for="i in 2" class="date-loader__dates-item date-loader__dates-item--empty"></div>
            <div v-for="i in 30" class="date-loader__dates-item date-loader__dates-item--filled"></div>
            <div v-for="i in 3" class="date-loader__dates-item date-loader__dates-item--empty"></div>
        </div>
    </div>
</template>